const SvgIcon = (props) => {
  switch (props.name) {
    case "logo":
      return (
        <svg
          {...props}
          title={props.name}
          width="85px"
          height="20px"
          viewBox="0 0 85 20"
          version="1.1"
        >
          <g id="redact-logo" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="logo" fill="#FFFFFF">
              <path
                d="M42.9884475,12.424643 C43.3345441,8.46842643 41.0341082,6.6146966 38.5163557,6.6146966 C35.9709357,6.6146966 33.4018724,8.46842643 33.0557757,12.424643 C32.7094276,16.3808597 34.9542768,18.234338 37.4996968,18.234338 C40.0174493,18.234338 42.6420993,16.3808597 42.9884475,12.424643 L42.9884475,12.424643 Z M45.9071288,0.251649484 L44.2126135,19.6177184 L42.2482132,19.6177184 L42.4612538,17.1832203 C41.2526823,18.9813634 39.1529623,19.894143 37.0225563,19.894143 C33.6747756,19.894143 30.7238993,17.5700638 31.1741268,12.424643 C31.6266179,7.25105161 34.9816929,4.95464003 38.3297251,4.95464003 C40.4598795,4.95464003 42.399882,5.86767114 43.2937973,7.66606576 L43.942477,0.251649484 L45.9071288,0.251649484 Z"
                id="Fill-7"
              ></path>
              <path
                d="M2.87066539,10.2112846 L7.71249703,10.2112846 C10.8666045,10.2112846 12.5970877,8.77256891 12.8247167,6.17206515 C13.0593883,3.48855856 11.5806804,2.04984288 8.42657288,2.04984288 L3.58474124,2.04984288 L2.87066539,10.2112846 Z M11.7866783,19.6175172 L7.96779361,12.0373468 L7.63553078,12.0373468 L2.7106963,12.0373468 L2.04767977,19.6175172 L2.51523722e-05,19.6175172 L1.69428894,0.251448265 L8.66677804,0.251448265 C13.1212631,0.251448265 15.2214862,2.49252463 14.8997874,6.17206515 C14.640718,9.13199631 12.9424298,11.1517318 9.92364207,11.8157544 L13.861749,19.6175172 L11.7866783,19.6175172 Z"
                id="Fill-1"
              ></path>
              <path
                d="M27.4038113,11.5668969 C27.6342071,8.30211894 26.0735024,6.53139194 23.3346606,6.53139194 C20.7339053,6.53139194 18.6543071,8.16403242 18.1904974,11.5668969 L27.4038113,11.5668969 Z M29.0764441,13.005361 L18.0370679,13.005361 C17.8630135,16.5742311 19.4790534,18.3447066 22.5501581,18.3447066 C24.2932175,18.3447066 26.0040818,17.7639383 26.9327074,15.6891191 L28.7308505,15.6891191 C27.4865626,18.8429751 24.9851592,19.9220118 22.3290687,19.9220118 C18.3446814,19.9220118 15.7333622,17.5146783 16.1740317,12.479928 C16.6313018,7.25100131 19.8480387,4.95458973 23.5001632,4.95458973 C27.1799552,4.95458973 29.6582184,7.30633653 29.2464741,12.0095786 C29.2054757,12.479928 29.1534103,12.7563525 29.0764441,13.005361 L29.0764441,13.005361 Z"
                id="Fill-4"
              ></path>
              <path
                d="M83.211618,18.1789776 L83.0760468,19.7281122 C82.5709871,19.811115 82.1006378,19.811115 81.6026208,19.811115 C79.5552177,19.811115 78.1084533,18.9536707 78.3333155,16.3808345 L79.171141,6.80834471 L76.8468103,6.80834471 L76.9848968,5.23129098 L79.308976,5.23129098 L79.6213684,1.66242089 L81.5855172,1.66242089 L81.2733762,5.23129098 L84.12314,5.23129098 L83.9850535,6.80834471 L81.1352897,6.80834471 L80.3316714,15.993488 C80.1913212,17.5977063 80.7215332,18.1789776 82.2985869,18.1789776 L83.211618,18.1789776 Z"
                id="Fill-13"
              ></path>
              <path
                d="M57.5881168,12.2030758 C57.5038563,12.5350871 56.8156874,12.8117632 55.5007214,12.9777689 L52.559403,13.3925315 C49.9546233,13.7524619 49.1577962,14.6378254 49.0466227,15.9102839 C48.8941993,17.6533433 50.1918102,18.317366 51.9346181,18.317366 C55.4763236,18.317366 57.28327,15.6889431 57.3801067,14.5824902 L57.5881168,12.2030758 Z M59.7582635,9.85158053 L58.9035858,19.6177436 L57.0501075,19.6177436 L57.2679271,17.1274072 L57.1849243,17.1274072 C56.7598492,17.8746842 54.9785582,19.8941682 51.4371042,19.8941682 C48.6703432,19.8941682 46.8422688,18.6493773 47.0721615,16.0212059 C47.2829384,13.6138724 49.0473773,12.4246682 52.2676355,11.9817349 L55.4579624,11.5669723 C56.9992997,11.3453799 57.6897324,11.0412877 57.7262033,10.6262736 L57.7938632,9.85158053 C58.014198,7.33382807 56.7611068,6.47613218 54.3540248,6.47613218 C51.8916075,6.47613218 50.5967634,7.36149568 50.4297517,9.27056073 L50.4033417,9.57490443 L48.5219442,9.57490443 L48.5604274,9.13222268 C48.8122026,6.25504283 51.0286296,4.95466519 54.5700836,4.95466519 C58.3328785,4.95466519 60.0608465,6.39338088 59.7582635,9.85158053 L59.7582635,9.85158053 Z"
                id="Fill-9"
              ></path>
              <path
                d="M61.9107029,12.4521597 C62.3584151,7.33390353 65.7758679,4.95474064 69.4833275,4.95474064 C72.0566667,4.95474064 74.9152338,6.11652872 75.0975885,10.0450777 L73.3268615,10.0450777 C73.104263,7.52757679 71.2475149,6.61479721 69.3107823,6.61479721 C66.4610185,6.61479721 64.1585704,8.57894595 63.8197679,12.4521597 C63.4857444,16.2700383 65.4443596,18.2341871 68.2941234,18.2341871 C70.230856,18.2341871 72.2473217,17.321156 72.9153687,14.7483198 L74.6860957,14.7483198 C73.8394669,18.732204 70.7497495,19.8942436 68.1764103,19.8942436 C64.4689506,19.8942436 61.4700333,17.4874131 61.9107029,12.4521597"
                id="Fill-11"
              ></path>
            </g>
          </g>
        </svg>
      );
    case "facebook":
    case "reddit":
    case "twitter":
    case "instagram":
    case "twitch":
    case "tiktok":
    case "flickr":
    case "vimeo":
    case "gyazo":
    case "imdb":
    case "pinterest":
    case "pixiv":
    case "bluesky":
    case "mastodon":
    case "deviantart":
    case "spotify":
    case "yelp":
    case "my-anime-list":
    case "letterboxd":
    case "steam":
    case "tumblr":
    case "imgur":
    case "yelp":
    case "youtube":
      return (
        <svg
          width={24}
          height={24}
          xmlns="http://www.w3.org/2000/svg"
          fillRule="evenodd"
          clipRule="evenodd"
          viewBox="0 0 24 24"
          {...props}
        >
          <path d="M12 0c6.623 0 12 5.377 12 12s-5.377 12-12 12S0 18.623 0 12 5.377 0 12 0m2.557 16H9.442c.546 2.46 1.441 4.114 2.558 5.744 1.194-1.741 2.041-3.41 2.557-5.744M7.4 16H2.833c1.236 2.825 3.704 4.972 6.755 5.716A17.556 17.556 0 017.4 16m13.767 0H16.6a17.617 17.617 0 01-2.175 5.694c3.012-.763 5.517-2.895 6.742-5.694M7.162 10H2.2a10.088 10.088 0 000 4h4.915a20.028 20.028 0 01.047-4m7.661 0H9.176a18.016 18.016 0 00-.053 4h5.753a18.017 18.017 0 00-.053-4m6.977 0h-4.963c.148 1.328.166 2.671.048 4H21.8c.26-1.285.273-2.648 0-4M9.644 2.271C6.567 3.003 4.077 5.157 2.833 8h4.653a20.424 20.424 0 012.158-5.729m2.355-.048C10.91 3.993 10.089 5.676 9.536 8h4.927c-.534-2.246-1.337-3.948-2.464-5.777m2.368.069A20.45 20.45 0 0116.513 8h4.654c-1.232-2.816-3.762-4.958-6.8-5.708" />
        </svg>
      );
    case "discord":
    case "whatsapp":
    case "telegram":
    case "skype":
    case "messenger":
    case "tinder":
    case "bumble":
    case "quora":
    case "disqus":
    case "vk-messenger":
    case "medium":
    case "imap":
    case "stack-exchange":
    case "rustlelogs":
      return (
        <svg
          width={75}
          height={75}
          viewBox="0 0 75 75"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M36.988 29.176h23.897a4.112 4.112 0 014.107 4.107v17.923a4.112 4.112 0 01-4.107 4.107H59.03c0 3.97-3.362 6.835-6.428 4.314-2.433-2-4.437-4.312-6.246-4.314h-9.368a4.113 4.113 0 01-4.107-4.107V33.283a4.112 4.112 0 014.107-4.107zm10.455 17.176h8.96a1.12 1.12 0 000-2.24h-8.96a1.12 1.12 0 100 2.24zm-5.975-5.974h14.936a1.12 1.12 0 000-2.24H41.468a1.12 1.12 0 000 2.24z"
            fill="#6C8EF8"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.115 12.5h23.898a4.112 4.112 0 014.107 4.107v10.42h-5.225l-.002.013v-.012a6.237 6.237 0 00-6.23 6.23v5.38h-2.018c-1.366.001-2.843 1.318-4.531 2.824-.548.49-1.12.999-1.716 1.489-3.066 2.52-6.428-.344-6.428-4.314h-1.855a4.112 4.112 0 01-4.107-4.107V16.607a4.111 4.111 0 014.107-4.107zm4.481 17.176h8.962a1.12 1.12 0 100-2.24h-8.962a1.12 1.12 0 000 2.24zm0-5.974h14.936a1.12 1.12 0 000-2.24H18.596a1.12 1.12 0 000 2.24z"
            fill="#B8C3E9"
          />
        </svg>
      );

    case "cancel":
      return (
        <svg
          {...props}
          title={props.name}
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z" />
        </svg>
      );

    case "teams":
    case "slack":
    case "linkedin":
    case "github":
    case "wordpress":
    case "blogger":
    case "ms-teams":
      return (
        <svg
          width={76}
          height={75}
          viewBox="0 0 76 75"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M35.15 47.944a2.532 2.532 0 110-5.063h5.064a2.532 2.532 0 010 5.063H35.15zm29.868-13.08a8.857 8.857 0 01-8.861 8.86H46.12v-.844a3.369 3.369 0 00-3.37-3.375H32.613a3.374 3.374 0 00-3.37 3.375v.844H19.206a8.86 8.86 0 01-8.86-8.86V27.69a5.063 5.063 0 015.063-5.063h10.457V19.25a6.749 6.749 0 016.747-6.751h10.136a6.753 6.753 0 016.747 6.751v3.376h10.458a5.063 5.063 0 015.063 5.063v7.173zM46.12 19.251a3.377 3.377 0 00-3.37-3.376H32.613a3.373 3.373 0 00-3.37 3.376v3.375H46.12v-3.375z"
            fill="#6C8EF8"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M29.242 46.465v.844a3.369 3.369 0 003.37 3.376H42.75a3.374 3.374 0 003.371-3.376v-.844h10.037a12.2 12.2 0 008.86-3.795v14.766a5.063 5.063 0 01-5.063 5.063H15.409a5.063 5.063 0 01-5.064-5.063V42.668a12.202 12.202 0 008.861 3.797h10.036z"
            fill="#B8C3E9"
          />
        </svg>
      );
    case "back":
      return (
        <svg
          {...props}
          title={props.name}
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path d="M0 12l9-8v6h15v4h-15v6z" />
        </svg>
      );
    case "settings":
      return (
        <svg
          {...props}
          title={props.name}
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path d="M24 13.616v-3.232c-1.651-.587-2.694-.752-3.219-2.019v-.001c-.527-1.271.1-2.134.847-3.707l-2.285-2.285c-1.561.742-2.433 1.375-3.707.847h-.001c-1.269-.526-1.435-1.576-2.019-3.219h-3.232c-.582 1.635-.749 2.692-2.019 3.219h-.001c-1.271.528-2.132-.098-3.707-.847l-2.285 2.285c.745 1.568 1.375 2.434.847 3.707-.527 1.271-1.584 1.438-3.219 2.02v3.232c1.632.58 2.692.749 3.219 2.019.53 1.282-.114 2.166-.847 3.707l2.285 2.286c1.562-.743 2.434-1.375 3.707-.847h.001c1.27.526 1.436 1.579 2.019 3.219h3.232c.582-1.636.75-2.69 2.027-3.222h.001c1.262-.524 2.12.101 3.698.851l2.285-2.286c-.744-1.563-1.375-2.433-.848-3.706.527-1.271 1.588-1.44 3.221-2.021zm-12 2.384c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4z" />
        </svg>
      );
    case "logout":
      return (
        <svg
          {...props}
          title={props.name}
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path d="M16 9v-4l8 7-8 7v-4h-8v-6h8zm-16-7v20h14v-2h-12v-16h12v-2h-14z" />
        </svg>
      );
    case "scheduler":
      return (
        <svg
          {...props}
          title={props.name}
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
        >
          <g fill="none" fillRule="evenodd">
            <g>
              <g transform="translate(-228 -79) translate(229 80)">
                <ellipse
                  cx="7"
                  cy="7.2"
                  stroke="#FFF"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth=".99"
                  rx="7"
                  ry="7.2"
                />
                <ellipse
                  cx="7"
                  cy="7.2"
                  stroke="#FFF"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth=".99"
                  rx="7"
                  ry="7.2"
                />
                <path
                  fill="#FFF"
                  d="M7.643 7.571c-4.02 2.818-6.028 4.23-6.024 4.234C2.903 13.391 4.837 14.4 7 14.4c3.866 0 7-3.224 7-7.2S10.866 0 7 0l.643 7.571z"
                />
                <circle
                  cx="7"
                  cy="7"
                  r="4"
                  stroke="#0F0F0F"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth=".99"
                />
              </g>
            </g>
          </g>
        </svg>
      );
    case "home":
      return (
        <svg
          {...props}
          title={props.name}
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
        >
          <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
            <g stroke="#FFF" strokeWidth=".99">
              <g>
                <g>
                  <path
                    d="M0 0H5.544V5.544H0zM8.712 0H14.256V5.544H8.712zM8.712 8.712H14.256V14.256H8.712zM0 8.712H5.544V14.256H0z"
                    transform="translate(-265 -79) translate(266 80)"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
      );
    case "placeholder":
      return (
        <svg
          {...props}
          width="45"
          height="45"
          viewBox="0 0 45 45"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.42857 0C4.72361 0 3.08848 0.677294 1.88288 1.88288C0.677294 3.08848 0 4.72361 0 6.42857V12.8571C0 14.5621 0.677294 16.1972 1.88288 17.4028C3.08848 18.6084 4.72361 19.2857 6.42857 19.2857H12.8571C14.5621 19.2857 16.1972 18.6084 17.4028 17.4028C18.6084 16.1972 19.2857 14.5621 19.2857 12.8571V6.42857C19.2857 4.72361 18.6084 3.08848 17.4028 1.88288C16.1972 0.677294 14.5621 0 12.8571 0H6.42857ZM6.42857 25.7143C4.72361 25.7143 3.08848 26.3916 1.88288 27.5972C0.677294 28.8028 0 30.4379 0 32.1429V38.5714C0 40.2764 0.677294 41.9115 1.88288 43.1171C3.08848 44.3227 4.72361 45 6.42857 45H12.8571C14.5621 45 16.1972 44.3227 17.4028 43.1171C18.6084 41.9115 19.2857 40.2764 19.2857 38.5714V32.1429C19.2857 30.4379 18.6084 28.8028 17.4028 27.5972C16.1972 26.3916 14.5621 25.7143 12.8571 25.7143H6.42857ZM25.7143 6.42857C25.7143 4.72361 26.3916 3.08848 27.5972 1.88288C28.8028 0.677294 30.4379 0 32.1429 0H38.5714C40.2764 0 41.9115 0.677294 43.1171 1.88288C44.3227 3.08848 45 4.72361 45 6.42857V12.8571C45 14.5621 44.3227 16.1972 43.1171 17.4028C41.9115 18.6084 40.2764 19.2857 38.5714 19.2857H32.1429C30.4379 19.2857 28.8028 18.6084 27.5972 17.4028C26.3916 16.1972 25.7143 14.5621 25.7143 12.8571V6.42857ZM35.3571 25.7143C36.2096 25.7143 37.0272 26.0529 37.63 26.6557C38.2328 27.2585 38.5714 28.0761 38.5714 28.9286V32.1429H41.7857C42.6382 32.1429 43.4558 32.4815 44.0586 33.0843C44.6614 33.6871 45 34.5047 45 35.3571C45 36.2096 44.6614 37.0272 44.0586 37.63C43.4558 38.2328 42.6382 38.5714 41.7857 38.5714H38.5714V41.7857C38.5714 42.6382 38.2328 43.4558 37.63 44.0586C37.0272 44.6614 36.2096 45 35.3571 45C34.5047 45 33.6871 44.6614 33.0843 44.0586C32.4815 43.4558 32.1429 42.6382 32.1429 41.7857V38.5714H28.9286C28.0761 38.5714 27.2585 38.2328 26.6557 37.63C26.0529 37.0272 25.7143 36.2096 25.7143 35.3571C25.7143 34.5047 26.0529 33.6871 26.6557 33.0843C27.2585 32.4815 28.0761 32.1429 28.9286 32.1429H32.1429V28.9286C32.1429 28.0761 32.4815 27.2585 33.0843 26.6557C33.6871 26.0529 34.5047 25.7143 35.3571 25.7143Z"
            fill="#DEDEDE"
          />
        </svg>
      );
    case "apple":
      return (
        <svg
          {...props}
          title={props.name}
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path d="M22 17.607c-.786 2.28-3.139 6.317-5.563 6.361-1.608.031-2.125-.953-3.963-.953-1.837 0-2.412.923-3.932.983-2.572.099-6.542-5.827-6.542-10.995 0-4.747 3.308-7.1 6.198-7.143 1.55-.028 3.014 1.045 3.959 1.045.949 0 2.727-1.29 4.596-1.101.782.033 2.979.315 4.389 2.377-3.741 2.442-3.158 7.549.858 9.426zm-5.222-17.607c-2.826.114-5.132 3.079-4.81 5.531 2.612.203 5.118-2.725 4.81-5.531z" />
        </svg>
      );
    case "checkmark":
      return (
        <svg
          {...props}
          title={props.name}
          width="49px"
          height="49px"
          viewBox="0 0 49 49"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            id="Web"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <g
              id="redact-web-landing"
              transform="translate(-369.000000, -4769.000000)"
              stroke="#FFFFFF"
              strokeWidth="2.2839963"
            >
              <g id="Group-11" transform="translate(174.000000, 4286.000000)">
                <g id="Group-12" transform="translate(197.000000, 477.000000)">
                  <g id="check-circle" transform="translate(0.000000, 7.000000)">
                    <path
                      d="M45.6799277,21.1193533 L45.6799277,23.22063 C45.6741442,33.3357325 39.0158977,42.2422384 29.3158985,45.1102252 C19.6158994,47.978212 9.18484833,44.1244779 3.6794156,35.6388699 C-1.82601714,27.1532619 -1.09434616,16.0571928 5.4776496,8.36796628 C12.0496454,0.6787398 22.8964075,-1.77194271 32.1358292,2.34490303"
                      id="Path"
                    ></path>
                    <polyline
                      id="Path"
                      points="45.6799277 4.94865892 22.8399639 27.8114628 15.9879747 20.9594736"
                    ></polyline>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      );
    case "windows":
      return (
        <svg
          {...props}
          title={props.name}
          xmlns="http://www.w3.org/2000/svg"
          width="39"
          height="39"
          viewBox="0 0 39 39"
        >
          <g fill="none" fillRule="evenodd">
            <g fill="var(--text-color)" fillRule="nonzero">
              <path
                d="M333 1015.558v13.165h15.876v-15.346L333 1015.558zm17.791-2.489l21.038-3.069v18.59H350.79v-15.52zM333 1030.343v13.165l15.876 2.223v-15.388H333zm17.791.207h21.038v18.412l-21.038-2.98v-15.432z"
                transform="translate(-333 -1010)"
              />
            </g>
          </g>
        </svg>
      );
    case "appstore":
      return (
        <svg
          {...props}
          title={props.name}
          xmlns="http://www.w3.org/2000/svg"
          fillRule="evenodd"
          strokeLinejoin="round"
          strokeMiterlimit="2"
          clipRule="evenodd"
          viewBox="0 0 24 24"
        >
          <g transform="matrix(1 0 0 1 -40 -40)">
            <rect width="24" height="24" x="40" y="40" fill="none" />
            <path
              fill="#2c2c2c"
              d="M398.9,292C398.9,291.231 398.594,290.493 398.051,289.949C397.507,289.406 396.769,289.1 396,289.1C392.168,289.1 383.832,289.1 380,289.1C379.231,289.1 378.493,289.406 377.949,289.949C377.406,290.493 377.1,291.231 377.1,292C377.1,295.832 377.1,304.168 377.1,308C377.1,308.769 377.406,309.507 377.949,310.051C378.493,310.594 379.231,310.9 380,310.9C383.832,310.9 392.168,310.9 396,310.9C396.769,310.9 397.507,310.594 398.051,310.051C398.594,309.507 398.9,308.769 398.9,308L398.9,292ZM397.1,292L397.1,308C397.1,308.292 396.984,308.572 396.778,308.778C396.572,308.984 396.292,309.1 396,309.1C392.168,309.1 383.832,309.1 380,309.1C379.708,309.1 379.428,308.984 379.222,308.778C379.016,308.572 378.9,308.292 378.9,308C378.9,304.168 378.9,295.832 378.9,292C378.9,291.708 379.016,291.428 379.222,291.222C379.428,291.016 379.708,290.9 380,290.9C383.832,290.9 392.168,290.9 396,290.9C396.292,290.9 396.572,291.016 396.778,291.222C396.984,291.428 397.1,291.708 397.1,292ZM392.637,306.329L388.468,298.884C388.226,298.45 388.381,297.901 388.814,297.659C389.248,297.416 389.796,297.571 390.039,298.004L392.231,301.92L394.49,301.92C394.987,301.92 395.39,302.323 395.39,302.82C395.39,303.317 394.987,303.72 394.49,303.72L393.239,303.72L394.207,305.45C394.45,305.883 394.295,306.432 393.861,306.675C393.428,306.917 392.879,306.762 392.637,306.329ZM382.392,304.286L381.731,305.442C381.484,305.873 381.634,306.424 382.065,306.671C382.496,306.917 383.046,306.768 383.293,306.336L383.955,305.18C384.201,304.749 384.052,304.199 383.621,303.952C383.19,303.706 382.639,303.855 382.392,304.286ZM386.993,296.248L386.043,294.55C385.8,294.117 385.955,293.568 386.388,293.325C386.822,293.083 387.371,293.238 387.613,293.671L388.036,294.426L388.473,293.664C388.719,293.232 389.27,293.083 389.701,293.329C390.132,293.576 390.282,294.127 390.035,294.558L388.84,296.646C388.821,296.685 388.799,296.723 388.775,296.759L385.821,301.92L389.254,301.92C389.75,301.92 390.154,302.323 390.154,302.82C390.154,303.317 389.75,303.72 389.254,303.72L381.51,303.72C381.013,303.72 380.61,303.317 380.61,302.82C380.61,302.323 381.013,301.92 381.51,301.92L383.747,301.92L386.993,296.248Z"
              transform="translate(-336 -248)"
            />
          </g>
        </svg>
      );
    case "playstore":
      return (
        <svg
          {...props}
          title={props.name}
          xmlns="http://www.w3.org/2000/svg"
          width="39"
          height="44"
          viewBox="0 0 39 44"
        >
          <g fill="none" fillRule="evenodd">
            <g fill="#FFF" fillRule="nonzero">
              <path
                d="M722.62 1006.544c-3.355-1.496-5.985.227-6.348 3.81l-.045 34.827h.045c.363 3.628 2.948 5.306 6.304 3.81l-.227.09 1.088-.544.272-.136.454-.272 20.724-12.017.136-.091 7.528-4.399-.045-.045c3.084-2.268 2.766-5.578-.09-7.664l.044-.046-7.3-4.262-.273-.227-.045.045-20.634-12.017-.499-.318m-.226-.09l-.046-.046h-.045m20.361 13.922l-4.398 5.442-12.38-15.237 16.778 9.795zm-21.223 26.121l-.09.046c-.137.045-.227.136-.318.181-2.494 1.225-3.945.09-4.036-2.72V1011.26v-.498c.181-2.676 1.723-3.719 4.217-2.359l.182.091 15.69 19.273-15.645 19.228zm4.444-2.585l12.38-15.191 4.445 5.441-16.825 9.75zm24.806-14.466c-.136.09-.272.227-.408.318-.136.09-.227.181-.363.226l-.861.5-4.762 2.765-4.898-5.986 4.853-5.94 4.716 2.766.77.454h.046c.182.09.363.226.5.317 1.813 1.315 2.176 3.084.407 4.58z"
                transform="translate(-716 -1006)"
              />
            </g>
          </g>
        </svg>
      );

    case "plus":
      return (
        <svg
          {...props}
          title={props.name}
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path d="M24 10h-10v-10h-4v10h-10v4h10v10h4v-10h10z" />
        </svg>
      );
    case "minus":
      return (
        <svg
          {...props}
          title={props.name}
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path d="M0 10h24v4h-24z" />
        </svg>
      );
    case "carousel-left":
      return (
        <svg
          {...props}
          title={props.name}
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 511.641 511.641"
          xmlSpace="preserve"
        >
          <g>
            <path
              d="M148.32,255.76L386.08,18c4.053-4.267,3.947-10.987-0.213-15.04c-4.16-3.947-10.667-3.947-14.827,0L125.707,248.293
       c-4.16,4.16-4.16,10.88,0,15.04L371.04,508.667c4.267,4.053,10.987,3.947,15.04-0.213c3.947-4.16,3.947-10.667,0-14.827
       L148.32,255.76z"
            />
          </g>
        </svg>
      );
    case "carousel-right":
      return (
        <svg
          {...props}
          title={props.name}
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 511.949 511.949"
          xmlSpace="preserve"
        >
          <g>
            <path
              d="M386.235,248.308L140.902,2.975c-4.267-4.053-10.987-3.947-15.04,0.213c-3.947,4.16-3.947,10.667,0,14.827l237.76,237.76
        l-237.76,237.867c-4.267,4.053-4.373,10.88-0.213,15.04c4.053,4.267,10.88,4.373,15.04,0.213c0.107-0.107,0.213-0.213,0.213-0.213
        l245.333-245.333C390.395,259.188,390.395,252.468,386.235,248.308z"
            />
          </g>
        </svg>
      );

    case "website":
      return (
        <svg
          {...props}
          title={props.name}
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm1 16.057v-3.057h2.994c-.059 1.143-.212 2.24-.456 3.279-.823-.12-1.674-.188-2.538-.222zm1.957 2.162c-.499 1.33-1.159 2.497-1.957 3.456v-3.62c.666.028 1.319.081 1.957.164zm-1.957-7.219v-3.015c.868-.034 1.721-.103 2.548-.224.238 1.027.389 2.111.446 3.239h-2.994zm0-5.014v-3.661c.806.969 1.471 2.15 1.971 3.496-.642.084-1.3.137-1.971.165zm2.703-3.267c1.237.496 2.354 1.228 3.29 2.146-.642.234-1.311.442-2.019.607-.344-.992-.775-1.91-1.271-2.753zm-7.241 13.56c-.244-1.039-.398-2.136-.456-3.279h2.994v3.057c-.865.034-1.714.102-2.538.222zm2.538 1.776v3.62c-.798-.959-1.458-2.126-1.957-3.456.638-.083 1.291-.136 1.957-.164zm-2.994-7.055c.057-1.128.207-2.212.446-3.239.827.121 1.68.19 2.548.224v3.015h-2.994zm1.024-5.179c.5-1.346 1.165-2.527 1.97-3.496v3.661c-.671-.028-1.329-.081-1.97-.165zm-2.005-.35c-.708-.165-1.377-.373-2.018-.607.937-.918 2.053-1.65 3.29-2.146-.496.844-.927 1.762-1.272 2.753zm-.549 1.918c-.264 1.151-.434 2.36-.492 3.611h-3.933c.165-1.658.739-3.197 1.617-4.518.88.361 1.816.67 2.808.907zm.009 9.262c-.988.236-1.92.542-2.797.9-.89-1.328-1.471-2.879-1.637-4.551h3.934c.058 1.265.231 2.488.5 3.651zm.553 1.917c.342.976.768 1.881 1.257 2.712-1.223-.49-2.326-1.211-3.256-2.115.636-.229 1.299-.435 1.999-.597zm9.924 0c.7.163 1.362.367 1.999.597-.931.903-2.034 1.625-3.257 2.116.489-.832.915-1.737 1.258-2.713zm.553-1.917c.27-1.163.442-2.386.501-3.651h3.934c-.167 1.672-.748 3.223-1.638 4.551-.877-.358-1.81-.664-2.797-.9zm.501-5.651c-.058-1.251-.229-2.46-.492-3.611.992-.237 1.929-.546 2.809-.907.877 1.321 1.451 2.86 1.616 4.518h-3.933z" />
        </svg>
      );
    case "schedule":
      return (
        <svg
          {...props}
          width="42"
          height="42"
          viewBox="0 0 42 42"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21 42C26.5695 42 31.911 39.7875 35.8492 35.8492C39.7875 31.911 42 26.5695 42 21C42 15.4305 39.7875 10.089 35.8492 6.15076C31.911 2.21249 26.5695 0 21 0C15.4305 0 10.089 2.21249 6.15076 6.15076C2.21249 10.089 0 15.4305 0 21C0 26.5695 2.21249 31.911 6.15076 35.8492C10.089 39.7875 15.4305 42 21 42ZM23.625 10.5C23.625 9.80381 23.3484 9.13613 22.8562 8.64385C22.3639 8.15156 21.6962 7.875 21 7.875C20.3038 7.875 19.6361 8.15156 19.1438 8.64385C18.6516 9.13613 18.375 9.80381 18.375 10.5V21C18.3751 21.6961 18.6518 22.3637 19.1441 22.8559L26.5676 30.282C26.8115 30.5259 27.1011 30.7194 27.4197 30.8513C27.7384 30.9833 28.0799 31.0513 28.4248 31.0513C28.7697 31.0513 29.1113 30.9833 29.4299 30.8513C29.7486 30.7194 30.0381 30.5259 30.282 30.282C30.5259 30.0381 30.7194 29.7486 30.8513 29.4299C30.9833 29.1113 31.0513 28.7697 31.0513 28.4248C31.0513 28.0799 30.9833 27.7384 30.8513 27.4197C30.7194 27.1011 30.5259 26.8115 30.282 26.5676L23.625 19.9133V10.5Z"
            fill="#DEDEDE"
          />
        </svg>
      );
    case "photos":
      return (
        <svg
          {...props}
          width="59"
          height="45"
          viewBox="0 0 59 45"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M38.0612 1.96722C36.8201 0.707631 35.1369 0 33.3817 0H6.91072C5.15558 0 3.47233 0.70763 2.23127 1.96722C0.990196 3.22681 0.29297 4.93519 0.29297 6.71652L0.292969 26.8661C0.292969 28.6474 0.990195 30.3558 2.23126 31.6154C3.47233 32.875 5.15558 33.5826 6.91072 33.5826L6.91072 6.71652L39.9995 6.71652C39.9995 4.93519 39.3022 3.22682 38.0612 1.96722ZM13.1782 12.7139C13.9329 11.9592 14.9565 11.5352 16.0238 11.5352H54.0472C55.1145 11.5352 56.1382 11.9592 56.8929 12.7139C57.6476 13.4686 58.0716 14.4922 58.0716 15.5595V40.9755C58.0716 42.0429 57.6476 43.0665 56.8929 43.8212C56.1382 44.5759 55.1145 44.9999 54.0472 44.9999H16.0238C14.9565 44.9999 13.9329 44.5759 13.1782 43.8212C12.4235 43.0665 11.9995 42.0429 11.9995 40.9755V15.5595C11.9995 14.4922 12.4235 13.4686 13.1782 12.7139ZM16.0238 40.9755H54.0472L46.6229 23.6083L39.8231 36.9511L29.6234 19.5839L16.0238 40.9755Z"
            fill="#DEDEDE"
          />
        </svg>
      );
    case "mail":
      return (
        <svg
          {...props}
          title={props.name}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.00299 5.884L9.99999 9.882L17.997 5.884C17.9674 5.37444 17.7441 4.89549 17.3728 4.54523C17.0015 4.19497 16.5104 3.99991 16 4H3.99999C3.48958 3.99991 2.99844 4.19497 2.62717 4.54523C2.2559 4.89549 2.03259 5.37444 2.00299 5.884Z"
            fill="#DEDEDE"
          />
          <path
            d="M18 8.11798L10 12.118L2 8.11798V14C2 14.5304 2.21071 15.0391 2.58579 15.4142C2.96086 15.7893 3.46957 16 4 16H16C16.5304 16 17.0391 15.7893 17.4142 15.4142C17.7893 15.0391 18 14.5304 18 14V8.11798Z"
            fill="#DEDEDE"
          />
        </svg>
      );
    case "lightbulb":
      return (
        <svg
          {...props}
          width="45"
          height="45"
          viewBox="0 0 45 45"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25.3125 2.8125C25.3125 2.06658 25.0162 1.35121 24.4887 0.823762C23.9613 0.296316 23.2459 0 22.5 0C21.7541 0 21.0387 0.296316 20.5113 0.823762C19.9838 1.35121 19.6875 2.06658 19.6875 2.8125V5.625C19.6875 6.37092 19.9838 7.08629 20.5113 7.61374C21.0387 8.14118 21.7541 8.4375 22.5 8.4375C23.2459 8.4375 23.9613 8.14118 24.4887 7.61374C25.0162 7.08629 25.3125 6.37092 25.3125 5.625V2.8125ZM38.4103 10.5666C38.9226 10.0361 39.2061 9.32568 39.1997 8.58825C39.1933 7.85082 38.8975 7.14541 38.3761 6.62395C37.8546 6.10249 37.1492 5.8067 36.4118 5.80029C35.6743 5.79388 34.9639 6.07737 34.4334 6.58969L32.445 8.57813C31.9327 9.10857 31.6492 9.81901 31.6556 10.5564C31.662 11.2939 31.9578 11.9993 32.4793 12.5207C33.0007 13.0422 33.7061 13.338 34.4436 13.3444C35.181 13.3508 35.8914 13.0673 36.4219 12.555L38.4103 10.5666ZM45 22.5C45 23.2459 44.7037 23.9613 44.1762 24.4887C43.6488 25.0162 42.9334 25.3125 42.1875 25.3125H39.375C38.6291 25.3125 37.9137 25.0162 37.3863 24.4887C36.8588 23.9613 36.5625 23.2459 36.5625 22.5C36.5625 21.7541 36.8588 21.0387 37.3863 20.5113C37.9137 19.9838 38.6291 19.6875 39.375 19.6875H42.1875C42.9334 19.6875 43.6488 19.9838 44.1762 20.5113C44.7037 21.0387 45 21.7541 45 22.5ZM8.57813 12.555C8.83757 12.8236 9.14791 13.0379 9.49105 13.1853C9.83419 13.3327 10.2032 13.4103 10.5767 13.4135C10.9501 13.4168 11.3205 13.3456 11.6661 13.2042C12.0118 13.0628 12.3258 12.8539 12.5899 12.5899C12.8539 12.3258 13.0628 12.0118 13.2042 11.6661C13.3456 11.3205 13.4168 10.9501 13.4135 10.5767C13.4103 10.2032 13.3327 9.83419 13.1853 9.49105C13.0379 9.14791 12.8236 8.83757 12.555 8.57813L10.5666 6.58969C10.0361 6.07737 9.32568 5.79388 8.58825 5.80029C7.85082 5.8067 7.14541 6.10249 6.62395 6.62395C6.10249 7.14541 5.8067 7.85082 5.80029 8.58825C5.79388 9.32568 6.07737 10.0361 6.58969 10.5666L8.57813 12.555ZM8.4375 22.5C8.4375 23.2459 8.14118 23.9613 7.61374 24.4887C7.08629 25.0162 6.37092 25.3125 5.625 25.3125H2.8125C2.06658 25.3125 1.35121 25.0162 0.823762 24.4887C0.296316 23.9613 0 23.2459 0 22.5C0 21.7541 0.296316 21.0387 0.823762 20.5113C1.35121 19.9838 2.06658 19.6875 2.8125 19.6875H5.625C6.37092 19.6875 7.08629 19.9838 7.61374 20.5113C8.14118 21.0387 8.4375 21.7541 8.4375 22.5ZM16.875 39.375V36.5625H28.125V39.375C28.125 40.8668 27.5324 42.2976 26.4775 43.3525C25.4226 44.4074 23.9918 45 22.5 45C21.0082 45 19.5774 44.4074 18.5225 43.3525C17.4676 42.2976 16.875 40.8668 16.875 39.375ZM28.125 33.75C28.1672 32.7938 28.71 31.9331 29.4666 31.3341C31.3022 29.8863 32.6413 27.9027 33.2976 25.6589C33.9539 23.415 33.8949 21.0225 33.1287 18.8137C32.3625 16.605 30.9273 14.6898 29.0225 13.3344C27.1176 11.979 24.8379 11.2506 22.5 11.2506C20.1621 11.2506 17.8824 11.979 15.9775 13.3344C14.0727 14.6898 12.6375 16.605 11.8713 18.8137C11.1051 21.0225 11.0461 23.415 11.7024 25.6589C12.3587 27.9027 13.6978 29.8863 15.5334 31.3341C16.2928 31.9331 16.8328 32.7938 16.8722 33.75H28.1278H28.125Z"
            fill="#DEDEDE"
          />
        </svg>
      );

    case "linux":
      return (
        <svg
          {...props}
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path d="M20.581 19.049c-.55-.446-.336-1.431-.907-1.917.553-3.365-.997-6.331-2.845-8.232-1.551-1.595-1.051-3.147-1.051-4.49 0-2.146-.881-4.41-3.55-4.41-2.853 0-3.635 2.38-3.663 3.738-.068 3.262.659 4.11-1.25 6.484-2.246 2.793-2.577 5.579-2.07 7.057-.237.276-.557.582-1.155.835-1.652.72-.441 1.925-.898 2.78-.13.243-.192.497-.192.74 0 .75.596 1.399 1.679 1.302 1.461-.13 2.809.905 3.681.905.77 0 1.402-.438 1.696-1.041 1.377-.339 3.077-.296 4.453.059.247.691.917 1.141 1.662 1.141 1.631 0 1.945-1.849 3.816-2.475.674-.225 1.013-.879 1.013-1.488 0-.39-.139-.761-.419-.988zm-9.147-10.465c-.319 0-.583-.258-1-.568-.528-.392-1.065-.618-1.059-1.03 0-.283.379-.37.869-.681.526-.333.731-.671 1.249-.671.53 0 .69.268 1.41.579.708.307 1.201.427 1.201.773 0 .355-.741.609-1.158.868-.613.378-.928.73-1.512.73zm1.665-5.215c.882.141.981 1.691.559 2.454l-.355-.145c.184-.543.181-1.437-.435-1.494-.391-.036-.643.48-.697.922-.153-.064-.32-.11-.523-.127.062-.923.658-1.737 1.451-1.61zm-3.403.331c.676-.168 1.075.618 1.078 1.435l-.31.19c-.042-.343-.195-.897-.579-.779-.411.128-.344 1.083-.115 1.279l-.306.17c-.42-.707-.419-2.133.232-2.295zm-2.115 19.243c-1.963-.893-2.63-.69-3.005-.69-.777 0-1.031-.579-.739-1.127.248-.465.171-.952.11-1.343-.094-.599-.111-.794.478-1.052.815-.346 1.177-.791 1.447-1.124.758-.937 1.523.537 2.15 1.85.407.851 1.208 1.282 1.455 2.225.227.871-.71 1.801-1.896 1.261zm6.987-1.874c-1.384.673-3.147.982-4.466.299-.195-.563-.507-.927-.843-1.293.539-.142.939-.814.46-1.489-.511-.721-1.555-1.224-2.61-2.04-.987-.763-1.299-2.644.045-4.746-.655 1.862-.272 3.578.057 4.069.068-.988.146-2.638 1.496-4.615.681-.998.691-2.316.706-3.14l.62.424c.456.337.838.708 1.386.708.81 0 1.258-.466 1.882-.853.244-.15.613-.302.923-.513.52 2.476 2.674 5.454 2.795 7.15.501-1.032-.142-3.514-.142-3.514.842 1.285.909 2.356.946 3.67.589.241 1.221.869 1.279 1.696l-.245-.028c-.126-.919-2.607-2.269-2.83-.539-1.19.181-.757 2.066-.997 3.288-.11.559-.314 1.001-.462 1.466zm4.846-.041c-.985.38-1.65 1.187-2.107 1.688-.88.966-2.044.503-2.168-.401-.131-.966.36-1.493.572-2.574.193-.987-.023-2.506.431-2.668.295 1.753 2.066 1.016 2.47.538.657 0 .712.222.859.837.092.385.219.709.578 1.09.418.447.29 1.133-.635 1.49zm-8-13.006c-.651 0-1.138-.433-1.534-.769-.203-.171.05-.487.253-.315.387.328.777.675 1.281.675.607 0 1.142-.519 1.867-.805.247-.097.388.285.143.382-.704.277-1.269.832-2.01.832z" />
        </svg>
      );

    case "business":
      return (
        <svg
          {...props}
          width="37"
          height="49"
          viewBox="0 0 37 49"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M36.0791 0.921875H0.579102V48.9219H10.8291V36.9219H25.8291V48.9219H36.0791V0.921875ZM6.7041 10.6602H15.2041V17.6602H6.7041V10.6602ZM15.2041 22.6602H6.7041V29.6602H15.2041V22.6602ZM21.4541 10.6602H29.9541V17.6602H21.4541V10.6602ZM29.9541 22.6602H21.4541V29.6602H29.9541V22.6602Z"
            fill="#DEDEDE"
          />
        </svg>
      );

    default:
      return (
        <svg
          width={75}
          height={75}
          viewBox="0 0 75 75"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.215 57.143h28.57V15.102a2.602 2.602 0 00-2.601-2.602H25.817a2.602 2.602 0 00-2.602 2.602v42.04zM37.5 25.077a12.5 12.5 0 11-12.5 12.5 12.514 12.514 0 0112.5-12.5zm-5.875-9.203c0-.391.317-.708.708-.708h7.054a.708.708 0 010 1.415h-7.054a.708.708 0 01-.708-.707zm9.765 0c0-.391.316-.708.707-.708h.568a.708.708 0 110 1.415h-.568a.708.708 0 01-.707-.707z"
            fill="#B8C3E9"
          />
          <path
            d="M23.215 59.822a2.68 2.68 0 002.678 2.678h23.214a2.679 2.679 0 002.679-2.678v-.893H23.214v.892z"
            fill="#B8C3E9"
          />
          <path
            d="M39.677 28.228l-.875.219a5.81 5.81 0 01-4.941-1.022c2.337-.826 4.891-.8 7.211.074-.402.348-.88.598-1.395.729zM40.384 40.27a1.623 1.623 0 01-1.309-1.716c.028-.39.194-.758.47-1.036a24.458 24.458 0 016.374-4.594l.886-.446a10.639 10.639 0 01.835 8.078l-.25-.188a5.23 5.23 0 00-5.854-.302 1.623 1.623 0 01-1.152.204z"
            fill="#6C8EF8"
          />
          <path
            d="M31.271 37.662a5.2 5.2 0 012.27 6.138 5.252 5.252 0 01-2.053 2.684 10.683 10.683 0 0015.476-4.205l-.643-.483a3.451 3.451 0 00-3.862-.198 3.417 3.417 0 01-4.173-5.345c2-2 4.309-3.665 6.839-4.928l.696-.349a10.771 10.771 0 00-3.035-2.663 5.223 5.223 0 01-2.68 1.648l-.874.218a7.573 7.573 0 01-7.16-1.945 10.768 10.768 0 00-4.412 4.79l1.544 2.574a6.04 6.04 0 002.067 2.064z"
            fill="#6C8EF8"
          />
          <path
            d="M31.817 40.948c.271.736.283 1.543.03 2.286a3.444 3.444 0 01-1.878 2.035 10.636 10.636 0 01-3.064-10.035l.77 1.28a7.819 7.819 0 002.678 2.678 3.42 3.42 0 011.464 1.756z"
            fill="#6C8EF8"
          />
        </svg>
      );
  }
};

export default SvgIcon;
